import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreatePage = _resolveComponent("CreatePage")!
  const _component_CustomerPage = _resolveComponent("CustomerPage")!
  const _component_LoginPage = _resolveComponent("LoginPage")!

  return ($setup.isLoggedIn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.permission)
          ? (_openBlock(), _createBlock(_component_CreatePage, { key: 0 }))
          : (_openBlock(), _createBlock(_component_CustomerPage, { key: 1 }))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_LoginPage)
      ]))
}